import axios from "axios";
import { deleteAllCookies, isEmpty, isEmptyObject } from "./tools";
import Cookies from "js-cookie";
import { _ckey } from "../address";
import localforage from "localforage";
import { useAPIPublic } from "./api";
import { store } from "../reducer/store";

export const app_Cookie = (key, value, issecure = false) => {
	try {
		if (!isEmpty(value)) {
			if (!issecure) {
				localStorage.setItem(key, value);
				// Cookies.set(key, value, {
				//   domain: process.env.REACT_APP_DOMAIN,
				//   secure: false,
				// });
			} else {
				// Cookies.set(key, value, { domain: process.env.REACT_APP_DOMAIN });
				localStorage.setItem(key, value);
			}
		} else {
			// return Cookies.get(key);
			return localStorage.getItem(key);
		}
	} catch (error) {
		return "";
	}
};

export const app_Cookie_Remove = async (key) => {
	try {
		Cookies.remove(key);
	} catch (error) {
		return "";
	}
};

export const setAuthorization = (token) => {
	axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const setAuthorizationWithOTP = (token) => {
	axios.defaults.headers.common["X-Second-Token"] = "Bearer " + token;
};

export const setToken = async (values) => {
	return new Promise((resolve) => {
		app_Cookie(_ckey.expireUTCTime, values.expireUTCTime);
		setLocalStorage(_ckey.token, values.token);

		// axios.defaults.headers.common["token"] = setToken.token;
		resolve();
	});
};
export const setTokenOTP = async (values) => {
	return new Promise((resolve) => {
		app_Cookie(_ckey.otpExpireTime, values.expireUTCTime);
		setSessionStorage(_ckey.otpToken, values.token);

		// axios.defaults.headers.common["token"] = setToken.token;
		resolve();
	});
};
export const setSessionStorage = (name, values) => {
	try {
		return sessionStorage.setItem(name, values);
	} catch (error) {
		return "";
	}
};
export const getSessionStorage = (name) => {
	try {
		return sessionStorage.getItem(name);
	} catch (error) {
		return "";
	}
};
export const setLocalStorage = (name, values) => {
	try {
		return localStorage.setItem(name, values);
	} catch (error) {
		return "";
	}
};
export const getLocalStorage = (name) => {
	try {
		return localStorage.getItem(name);
	} catch (error) {
		return "";
	}
};

const getDistanceToExpireUtc = (expireUTCTime) => {
	if (!expireUTCTime) return 0;

	const [datePart, timePart] = expireUTCTime.split("T");
	if (!datePart || !timePart) return 0;

	const [y, m, d] = datePart.split("-").map((n) => parseInt(n, 10));

	// جدا کردن زمان از میلی‌ثانیه‌ها
	const [timeWithoutMs] = timePart.split(".");
	const [H, M, S] = timeWithoutMs.split(":").map((n) => parseInt(n, 10));

	const utcDate = new Date(Date.UTC(y, m - 1, d, H, M, S || 0));

	return utcDate.getTime() - Date.now();
};

export const CheckToken = async () => {
	const { refreshToken } = useAPIPublic();

	try {
		const _token = getLocalStorage(_ckey.token);
		const _expireUTCTime = app_Cookie(_ckey.expireUTCTime);

		if (isEmpty(_token) || isEmpty(_expireUTCTime)) {
			return false;
		}

		// ست کردن توکن فعلی روی axios برای درخواست رفرش
		await setToken({ token: _token, expireUTCTime: _expireUTCTime });
		setAuthorization(_token);

		const distance = getDistanceToExpireUtc(_expireUTCTime);

		// اگر تا انقضا <= ۵ دقیقه بود، رفرش کن
		if (distance <= process.env.REFRESH_THRESHOLD_MS) {
			const resp = await refreshToken({ token: _token });
			if (resp) {
				await setToken({ token: resp.token, expireUTCTime: resp.expireUTCTime });
				setAuthorization(resp.token);
				return true;
			}
			return false;
		}

		// هنوز زودتر از ۵ دقیقه به انقضا هست، همون قبلی اوکیه
		return true;
	} catch (e) {
		console.log(e);
		return false;
	}
};

export const CheckTokenWithOTP = async () => {
	const { refreshToken } = useAPIPublic();

	try {
		const _token = getSessionStorage(_ckey.otpToken);
		const _expireUTCTime = app_Cookie(_ckey.otpExpireTime);

		if (isEmpty(_token) || isEmpty(_expireUTCTime)) {
			return false;
		}

		// ست کردن توکن OTP روی axios
		await setTokenOTP({ token: _token, expireUTCTime: _expireUTCTime });
		setAuthorizationWithOTP(_token);

		const distance = getDistanceToExpireUtc(_expireUTCTime);

		// اگر تا انقضا <= ۵ دقیقه بود، رفرش کن
		if (distance <= process.env.REFRESH_THRESHOLD_MS) {
			const resp = await refreshToken({ token: _token });
			if (resp) {
				await setTokenOTP({ token: resp.token, expireUTCTime: resp.expireUTCTime });
				setAuthorizationWithOTP(resp.token);
				return true;
			}
			return false;
		}

		return true;
	} catch (e) {
		console.log(e);
		return false;
	}
};
export const clearApp = () => {
	sessionStorage.clear();
	localStorage.clear();
	deleteAllCookies();
};

export const clearAuthOnly = () => {
	try {
		localStorage.removeItem(_ckey.token);
	} catch {}
	try {
		localStorage.removeItem(_ckey.expireUTCTime);
	} catch {}
};

export const DocType = {
	PreparednessCard: "PreparednessCard",
	Passport: "Passport",
	BirthCertificate: "BirthCertificate",
	DrivingLicense: "DrivingLicense",
	CertNoCard: "CertNoCard",
	SIMCardPuck: "SIMCardPuck",
	Other: "Other",
	RequestDoc: "RequestDoc",
	SPDocument: "SPDocument",
	SWDocument: "SWDocument",
	IdentityCard: "IdentityCard",
	RefugeeCard: "RefugeeCard",
	CODocument: "CODocument",
};
export const CertType = {
	NationalNo: 0,
	PassportNo: 1,
	PreparednessCard: 2,
	RefugeeCard: 3,
	IdentityCard: 4,
};

export const Roles = {
	Global: "global",
	Show_OTPCode_ToDealer: "Show_OTPCode_ToDealer",
	UpdateDealerWallet: "UpdateDealerWallet",
	Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc: "Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc",
	APIQueryWalletAmount: "APIQueryWalletAmount",
	Dealer_RegisterSim_Report_UploadingDoc: "Dealer_RegisterSim_Report_UploadingDoc",
	UpdateDealerWalletByCurrentUser: "UpdateDealerWalletByCurrentUser",
	Dealer_Wallet_Management: "Dealer_Wallet_Management",
	Dealer_ChangeOwner_Report_One: "Dealer_ChangeOwner_Report_One",
	SimSwapDealer: "SimSwapDealer",
	ByPassDocumentUploudSimswap_ByDealer: "ByPassDocumentUploudSimswap_ByDealer",
	Dealer_EPPurchase_ReportOne: "Dealer_EPPurchase_ReportOne",
	Dealer_RegisterSim_B2C_NonIranian: "Dealer_RegisterSim_B2C_NonIranian",
	Dealer_DCPurchase_B2C: "Dealer_DCPurchase_B2C",
	Dealer_HotBill_Pay: "Dealer_HotBill_Pay", //
	SimRegistrationDelear: "SimRegistrationDelear",
	Dealer_EPPurchase_B2C: "Dealer_EPPurchase_B2C",
	Dealer_SimSwap_B2C_Iranian: "Dealer_SimSwap_B2C_Iranian",
	Dealer_RegisterSim_B2C_Iranian: "Dealer_RegisterSim_B2C_Iranian",
	CreateUserMenue: "CreateUserMenue",
	APICheckSubscriberIsAllowToSales: "APICheckSubscriberIsAllowToSales",
	Dealer_SimSwap_B2C_Iranian_DeliveryAreas: "Dealer_SimSwap_B2C_Iranian_DeliveryAreas",
	Dealer_DCPurchase_ReportOne: "Dealer_DCPurchase_ReportOne",
	Security_API: "Security_API",
	Dealer_ChangeOwner_B2C_Iranian: "Dealer_ChangeOwner_B2C_Iranian",
	NeginTel_API: "NeginTel_API",
	Dealer_ChangeOwner_Report_UploadingDoc: "Dealer_ChangeOwner_Report_UploadingDoc",
	Dealer_SimSwap_Report_UploadingDoc: "Dealer_SimSwap_Report_UploadingDoc",
	Dealer_SimSwap_B2B_Iranian: "Dealer_SimSwap_B2B_Iranian",
	Dealer_SimSwap_Report_One: "Dealer_SimSwap_Report_One",
	Dealer_SimSwap_Can_PickupMethodOfReceipt: "Dealer_SimSwap_Can_PickupMethodOfReceipt",
	Didban_API: "Didban_API",
	APIQueryOffer: "APIQueryOffer",
	Dealer_API: "Dealer_API",
	SalesChargeDelaer: "SalesChargeDelaer",
	USSD_API: "USSD_API",
	Public_API: "Public_API",
	Dealer_RegisterSim_Report_One: "Dealer_RegisterSim_Report_One",
	SalesEPackageDelaer: "SalesEPackageDelaer",
	Dealer: "Dealer",
	User_Can_SimSwap_B2B: "User_Can_SimSwap_B2B",
	Dealer_Wallet_AccessCC: "Dealer_Wallet_AccessCC",
	Dealer_Wallet_AccessCP: "Dealer_Wallet_AccessCP",
	Dealer_Wallet_AccessOtherSales: "Dealer_Wallet_AccessOtherSales",
	Dealer_Wallet_AccessAsanWallet: "Dealer_Wallet_AccessAsanWallet",
	Dealer_SimSwap_B2C_UploadPassportDoc: "Dealer_SimSwap_B2C_UploadPassportDoc",
	Dealer_RegisterSim_B2C_UploadPassportDoc: "Dealer_RegisterSim_B2C_UploadPassportDoc",
	Dealer_RegisterSim_Allow_Get_Signature_FromCustomer: "Dealer_RegisterSim_Allow_Get_Signature_FromCustomer",
	CRM_RegisterSim_Catable_Post: "CRM_RegisterSim_Catable_Post",
	Dealer_RegisterSim_Allow_Select_Method_Of_Receipt: "Dealer_RegisterSim_Allow_Select_Method_Of_Receipt",
	Delear_360_Customerservice: "Delear_360_Customerservice",
	Dealer_Wallet_Report_RevenueShare: "Dealer_Wallet_Report_RevenueShare",
	Dealer_UpdateMobile_Network: "Dealer_UpdateMobile_Network",
	Dealer_Query_Mobile_Network: "Dealer_Query_Mobile_Network",
	Dealer_SearchB2B_Subscription: "Dealer_SearchB2B_Subscription",
	Dealer_Register_B2C_BankCard: "Dealer_Register_B2C_BankCard",
	Dealer_GroupActivation_Charge_API: "Dealer_GroupActivation_Charge_API",
	Dealer_DastaneMan: "Dealer_DastaneMan",
	Dealer_AsanBimeh: "Dealer_AsanBimeh",
	Dealer_ChangeOwner_B2BCustomer_Iranian: "Dealer_ChangeOwner_B2BCustomer_Iranian",
	Dealer_ChangeStatus_B2B: "Dealer_ChangeStatus_B2B",
	Dealer_RequsetKit: "Dealer_RequsetKit",
	Dealer_AssignKit: "Dealer_AssignKit",
	// Dealer_Register_B2C_BankCard: "Dealer_SearchB2B_Subscription",
};

export const switchPlanID = () => {
	if (!isEmpty(getSessionStorage("userDealer"))) {
		const simPurchase = 30361;
		const simPurchaseForeign = 30362;
		const directCharge = 30363;
		const extraPackage = 30364;
		return {
			simPurchase,
			simPurchaseForeign,
			directCharge,
			extraPackage,
		};
	} else {
		const simPurchase = process.env.REACT_APP_PLANID_SIMCARDPURCHASE;
		const simPurchaseForeign = process.env.REACT_APP_PLANID_SIMCARDPURCHASE_FOREIGN;
		const directCharge = process.env.REACT_APP_PLANID_DIRECT_CHARGE;
		const extraPackage = process.env.REACT_APP_PLANID_EXTRA_PACKAGE;
		return {
			simPurchase,
			simPurchaseForeign,
			directCharge,
			extraPackage,
		};
	}
};

export async function onRehydrateAuth() {
	try {
		// 1) اگر توکن/انقضا نداریم، خروج تمیز
		const token = getLocalStorage(_ckey.token);
		const expire = app_Cookie(_ckey.expireUTCTime);
		if (!token || !expire) {
			clearAuthOnly();
			// به صفحه ورود یا صفحه‌ی refresh خودت
			window.location.replace(process.env.REACT_APP_ROOT);
			return;
		}

		// 2) هدر را ست کن که ریکوئست‌های بعدی 401 نزنند
		await setToken({ token, expireUTCTime: expire });
		setAuthorization(token);

		// 3) اگر persist کاملاً خالی بود یا کاربر هنوز ننشسته، تلا‌ش کن سشن را ترمیم کنی
		const state = store.getState?.();
		const hasUser = !!state?.another?._currentUser;

		// (اختیاری) نگاه به persist:root — اگر اصلاً وجود نداشته باشد یعنی اولین بار استارت شده
		const persistRaw = await localforage.getItem("persist:root").catch(() => null);
		const persistMissing = !persistRaw;

		if (persistMissing || !hasUser) {
			const ok = await CheckToken(); // نزدیک انقضا → رفرش؛ در غیر این صورت true
			if (!ok) {
				clearAuthOnly();
				window.location.replace("/login");
				return;
			}
			// اگر API «me» جدا داری و می‌خواهی همین‌جا کاربر را بگیری، می‌تونی اینجا صدا بزنی
			// await dispatch(fetchMeThunk())  ← اختیاری
		}

		// موفق: هیچ کاری لازم نیست، اپ بالا می‌آید.
	} catch (e) {
		// در هر خطای غیرمنتظره، خروج تمیز
		clearAuthOnly();
		window.location.replace("/login");
	}
}
